import React, { useState, useRef, useEffect } from "react";
import { Empty, Button, Checkbox, Select, Input } from "antd";
import { useNavigate } from "react-router-dom";

import "./TableSelectable.scss";
import useQCEStore from "../../store/qce.store";
import useJDStore from "../../store/jd.store";

export default function LeavesConfigTable({
  isClickable = false,
  titleList,
  data,
  isEditField = true,
  config,
  modifyTable,
  handleCallBack
}) {

  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [checkBoxData, setCheckBoxData] = useState([]); 
  const [currentData, setCurrentData] = useState([...data]); 
  const [newSkillAdded, setNewSkillAdded] = useState(false);
  const [skillRemoved, setSkillRemoved] = useState(false);

  const ResetCheckBox = () => { 
    var checkBoxResetArray = data?.map((item,idx) => {
      return {
        select:"",
        id:idx,
        leavetype: item.leavetype,
        maxleaves: item.maxleaves,
        carryforward: item.carryforward,
        isSelected: false,
      };
    });
    setCheckBoxData(() => [...checkBoxResetArray]);
  };

  useEffect(() => {

    const checkBoxArray = data?.map((item,idx) => {
      return {
        select:"",
        id:idx,
        leavetype: item.leavetype,
        maxleaves: item.maxleaves,
        carryforward: item.carryforward,
        isSelected: false,
      };
    });
    setCurrentData([...data])
    setCheckBoxData([...checkBoxArray]);
  }, [data]);

  if (!data) {
    return <Empty style={{ margin: "60px" }} />;
  }

  function enableDbUpdate() {
    for (let idx = 0; idx < checkBoxData.length; idx++) {
      if (checkBoxData[idx].isSelected) {
        return true;
      }
    }
    return false;
  }
  const onCheckBoxChange = (e) => {
    if (e.target.checked) {
      checkBoxData[e.target.value].isSelected = true;
    } else {
      checkBoxData[e.target.value].isSelected = false;
    }
    if (enableDbUpdate() == true) {
      setUpdateAvailable(true);
    } else {
      setUpdateAvailable(false);
    }
    setCheckBoxData(() => [...checkBoxData]);
  };

  
  const OnSelectChange = (value, field) => {
    const answer_array = value.split("#");
    var val = answer_array[1];
    var idx = answer_array[0];
    var idxInt = parseInt(idx);
    const updatedValues = [...checkBoxData];

    if (field === "assessmenttype") {
        updatedValues[idxInt] = { ...updatedValues[idxInt], ["assessmenttype"]: val };
    } else if (field === "weightage") {
        updatedValues[idxInt] = { ...updatedValues[idxInt], ["weightage"]: val };
    }else if (field === "difficultylevel") {
        updatedValues[idxInt] = { ...updatedValues[idxInt], ["difficultylevel"]: val };
    }
    setCheckBoxData(updatedValues);    
  };


  function getTimeNow() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    const currentDate = date + "-" + month + "-" + year;
    return currentDate;
  }

  const getUpdated = (rowIndex) => {
    return checkBoxData[rowIndex]?.isSelected;
  };

  const handleChange = (event, index) => {
    const { name, value } = event.target;
    const updatedValues = [...checkBoxData];
    updatedValues[index] = { ...updatedValues[index], [name]: value };
    setCheckBoxData(updatedValues);
  };


   const encodeJson = (updateType) =>{

        let encodedJsonValues ={};
        const userData = JSON.parse(localStorage.getItem("userDetails"));
        //now fill the parameters
        encodedJsonValues.skillarray =[];
        encodedJsonValues.leavesListNew = [];
        
        var num=0
        for(let idx = 0; idx < checkBoxData.length; idx++){
           //console.log("checkBoxData", idx,checkBoxData[idx])
           if (checkBoxData[idx].isSelected && updateType =="UPDATE" ) {
                encodedJsonValues.action = "UPDATE"
                encodedJsonValues.leavesListNew[num]={};
                encodedJsonValues.leavesListNew[num].leaveid =idx;
                encodedJsonValues.leavesListNew[num].leavetype = checkBoxData[idx].leavetype;
                encodedJsonValues.leavesListNew[num].maxleaves =parseInt(checkBoxData[idx].maxleaves,10);
                encodedJsonValues.leavesListNew[num].carryforward =parseInt(checkBoxData[idx].carryforward);
                num++;                  
            } else if (checkBoxData[idx].isSelected && updateType =="DELETE" ) {
                encodedJsonValues.action = "DELETE"
                encodedJsonValues.skillarray[num]={};
                encodedJsonValues.skillarray[num].skillid =idx;
                encodedJsonValues.skillarray[num].skill =checkBoxData[idx].skill; 
                num++;               
            }                       
        } 
        if (updateType =="ADD" ) {
            var idx = checkBoxData.length -1 
            num =0
            encodedJsonValues.action = "ADD"
            encodedJsonValues.skillarray[num]={};
            encodedJsonValues.skillarray[num].skillid =idx;
            encodedJsonValues.skillarray[num].skill =checkBoxData[idx].skill;
            encodedJsonValues.skillarray[num].assessmenttype =checkBoxData[idx].assessmenttype;
            encodedJsonValues.skillarray[num].difficultylevel =checkBoxData[idx].difficultylevel;
            encodedJsonValues.skillarray[num].noofquestions =checkBoxData[idx].noofquestions;
            encodedJsonValues.skillarray[num].weightage =checkBoxData[idx].weightage;
            if(encodedJsonValues.skillarray[num].weightage == "Mandatory"){
                encodedJsonValues.skillarray[num].weightage =1
            }else{
                encodedJsonValues.skillarray[num].weightage =0
            }
            encodedJsonValues.skillarray[num].passingmarks =checkBoxData[idx].passingmarks;            
        }               
        //get the current date
        let newDate = getTimeNow()
        encodedJsonValues.updatetype = updateType
        encodedJsonValues.updatedby= userData.qhuid;
        encodedJsonValues.updatedbyname= userData.username;
        encodedJsonValues.updatedon    = newDate;
             
        return encodedJsonValues
    }

const handleEvalCancel = (value) => {
    for(let idx = 0; idx < checkBoxData.length; idx++){
      checkBoxData[idx].isSelected = false;
    }    
    setCheckBoxData(() => [...checkBoxData]);    
    setUpdateAvailable(false);
}

const handleEvalSave = (value) => {
    var jasonValues= encodeJson("UPDATE")
    handleCallBack(jasonValues,"UPDATE")
    for(let idx = 0; idx < checkBoxData.length; idx++){
      checkBoxData[idx].isSelected = false;
    }    
    setCheckBoxData(() => [...checkBoxData]);    
    setUpdateAvailable(false);
}


const handleRemove = (value) => {
    //please remember ...did only to rerender the table. If we do
    setSkillRemoved(true)     
    setUpdateAvailable(false);
}
  const handleAddItem = () => {
    const newItemC = 
               {
	                select: "",
                  id: checkBoxData.length+1,
                  leavetype: "Please Add",
                  maxleaves: 3,
                  carryforward: 1,
              }
    const newItem = 
               {
	                select: "",
                  id: checkBoxData.length,
                  leavetype: "Please Add",
                  maxleaves: 3,
                  carryforward: 1,
                  isSelected: false,
              } 
    console.log("adding new item",newItemC)                           
    setCurrentData([...currentData, newItemC])
    setCheckBoxData([...checkBoxData, newItem]);

    //please remember ...did only to rerender the table. If we do
    setNewSkillAdded(true)   
    
  };

  function handleNewSkillAdded () {
    var jasonValues= encodeJson("ADD")
    handleCallBack(jasonValues,"ADD")
    for(let idx = 0; idx < checkBoxData.length; idx++){
      checkBoxData[idx].isSelected = false;
    }   
    setNewSkillAdded(false)       
  };

  function handleSkillRemoved () {
    var jasonValues= encodeJson("DELETE")
    handleCallBack(jasonValues,"DELETE")
    var tmp = checkBoxData
    var tmpData = currentData
    for(let idx = 0; idx < checkBoxData.length; idx++){
      if(checkBoxData[idx].isSelected == true){
         tmp = tmp.filter((item)=> item.id != idx)
         tmpData = tmpData.filter((item)=> item.id-1 != idx)
      }
      checkBoxData[idx].isSelected = false;
    }   
    //reset the ids
    for(let idx = 0; idx < tmp.length; idx++){
      tmp[idx].id = idx
      tmpData[idx.id] = idx+1
    }

    setCheckBoxData([...tmp]);   
    setCurrentData([...tmpData]);     
    setSkillRemoved(false)       
  };  

  return (
    <div className="evaluation-Setting-table-wrapper">
      <div className="rtable-selectable-btn-wrapper">  
        {
          modifyTable?
          <>
            <Button
              className="rtable-selectable-btn"
              onClick={handleAddItem}
            >
              Add New Holiday
            </Button>             
          </>
          :<>
          </>
        }      

      </div>
      <div
        className="rtable-title-wrapper"
        style={{
          gridTemplateColumns: config,
        }}
      >
        {titleList.map((title) =>
            <div className="rtable-title">{title}</div>
        )}
      </div>
      {currentData?.map((table, rowIndex) => (
        <div
          key={table.id}
          className="rtable-info-wrapper"
          style={{
            gridTemplateColumns: config,
            cursor: isClickable && "pointer",
          }}
        >
          {Object.keys(table)?.map((tableInfo, idx) => (
            <div className="rtable-info">
              {isEditField ? (
                <div className="edit-field-wrapper">
                  <>
                    {tableInfo === "id" ? rowIndex + 1 : <></>}

                    {tableInfo === "select" ? (
                      <Checkbox
                        value={rowIndex}
                        onChange={onCheckBoxChange}
                        checked={getUpdated(rowIndex)}
                      ></Checkbox>
                    ) : (
                      <></>
                    )}
                    {tableInfo === "leavetype" ? (
                      <>
                       {table[tableInfo]}
                      </>
                    ) : (
                      <></>
                    )}
                    {tableInfo === "maxleaves" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Input
                            type="number"
                            style={{
                              width: "auto",
                              height: 24,
                              textAlign: "center",
                            }}
                            name="maxleaves"
                            value={checkBoxData[rowIndex]?.maxleaves}
                            placeholder={checkBoxData[rowIndex]?.maxleaves}
                            onChange={(event) => handleChange(event, rowIndex)}
                          />
                        ) : (
                          table[tableInfo]
                        )}
                      </>
                    ) : (
                      <></>
                    )}                    
                    {tableInfo === "carryforward" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Input
                            style={{
                              width: "auto",
                              height: 24,
                              textAlign: "center",
                            }}
                            name="carryforward"
                            value={checkBoxData[rowIndex]?.carryforward}
                            placeholder={checkBoxData[rowIndex]?.carryforward}
                            onChange={(event) => handleChange(event, rowIndex)}
                          />
                        ) : (
                          table[tableInfo]
                        )}
                      </>
                    ) : (
                      <></>
                    )}  
                    {tableInfo === "date" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Input
                            style={{
                              width: "auto",
                              height: 24,
                              textAlign: "center",
                            }}
                            name="skill"
                            value={checkBoxData[rowIndex]?.date}
                            placeholder={checkBoxData[rowIndex]?.date}
                            onChange={(event) => handleChange(event, rowIndex)}
                          />
                        ) : (
                          table[tableInfo]
                        )}
                      </>
                    ) : (
                      <></>
                    )}                                                           
                  </>
                </div>
              ) : (
                table[tableInfo]
              )}
            </div>
          ))}
        </div>
      ))}
      <div className="rtable-selectable-btn-wrapper" style={{ marginTop: "10px" }}>
        <Button
          className="rtable-selectable-btn"
          disabled={!updateAvailable}
          onClick={handleEvalSave}
        >
          Save Changes
        </Button>
        {
          modifyTable?
          <>
            <Button
              className="rtable-selectable-btn"
              disabled={!updateAvailable}
              onClick={handleRemove}
            >
              Remove Skill
            </Button>          
          </>
          :<></>
        }  
        <Button
          className="rtable-selectable-btn"
          disabled={!updateAvailable}
          onClick={handleEvalCancel}
        >
          Cancel Selection
        </Button>               
      </div>   
      {newSkillAdded? handleNewSkillAdded():<></>}   
      {skillRemoved? handleSkillRemoved():<></>}  
    </div>
  );
}
